export enum ConfirmationType {
  Archive = 1,
  Delete = 2,
  CancelSubscriptions = 3,
}
